import type { SubAccount_Output } from '@/client'
import type { SubAccount } from '@/types/software'

type SubAccountRecord = Record<string, SubAccount_Output | SubAccount | undefined>

export function normalizeSubAccountParam(param: unknown): string | undefined {
  if (typeof param !== 'string') return undefined

  try {
    return decodeURIComponent(param)
  } catch (error) {
    console.warn('Failed to decode subAccountId param', error)
    return param
  }
}

export function selectPreferredSubAccount(
  subAccounts: SubAccountRecord | undefined,
  requestedId?: string
): { id: string; subAccount: SubAccount_Output | SubAccount } | undefined {
  if (!subAccounts) return undefined

  if (requestedId && subAccounts[requestedId]) {
    return { id: requestedId, subAccount: subAccounts[requestedId]! }
  }

  const fallbackId = Object.keys(subAccounts).find((key) =>
    Boolean(subAccounts[key])
  )

  if (!fallbackId) return undefined

  return { id: fallbackId, subAccount: subAccounts[fallbackId]! }
}
